<div [formGroup]="itemForm" class="card">
  @if (isWhatsappPhone() || isContactName()) {
  <div class="card-body">
    <div class="mb-1">
      <div class="d-flex align-items-start justify-content-between">
        <label class="text-dark fw-bold mb-1" style="font-size: 20px">
          {{ getLabel() }}
        </label>

        @if (!isRequired()) {
        <button
          type="button"
          class="btn btn-link p-0 ms-2"
          (click)="!isActive && deleteComponent()"
          [disabled]="isActive"
          [attr.aria-label]="'integrations.santriItem.removeAriaLabel' | translate"
        >
          <i class="bi bi-trash fs-4 text-danger"></i>
        </button>
        }
      </div>
      <p class="text-muted mb-0">
        {{ itemForm.get("helpText")?.value || getMessage() }}
      </p>
    </div>
    <div class="col-xs-12 mb-1">
      <textarea
        #messageTextarea
        class="form-control mb-1"
        maxlength="320"
        [placeholder]="'integrations.santriItem.typePlaceholder' | translate"
        formControlName="value"
        (keydown)="onKeydown($event)"
      ></textarea>
      <field-error-component
        [field]="'value'"
        [label]="'integrations.fields.value' | translate"
        [formGroup]="itemForm"
      />
      <div class="col-12">
        <div class="request-container">
          @for (request of webhookRequests | keyvalue; track $index) {
          <div class="d-flex mb-2">
            <span
              class="fw-bold text-dark me-1"
              (click)="!isActive && addValue(request.key)"
            >
              {{ request.key }}:
            </span>
            <span class="text-break">{{ request.value }}</span>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  } @else if (isAddTag() || isRemoveTag()) {
  <div class="card-body">
    <div class="mb-1">
      <div class="d-flex align-items-start justify-content-between">
        <label class="text-dark fw-bold mb-1" style="font-size: 20px">
          {{ getLabel() }}
        </label>

        @if (!isRequired()) {
        <button
          type="button"
          class="btn btn-link p-0 ms-2"
          (click)="!isActive && deleteComponent()"
        >
          <i class="bi bi-trash fs-4 text-danger"></i>
        </button>
        }
      </div>

      <p class="text-muted mb-0">
        {{ itemForm.get("helpText")?.value || getMessage() }}
      </p>
    </div>
    <div class="col-12">
      <div class="mb-1 position-relative" style="z-index: 1">
        <select
          class="form-select"
          formControlName="value"
          [attr.placeholder]="'integrations.santriItem.selectTagPlaceholder' | translate"
          panelClass="custom-select-panel"
        >
          @for(item of tags; track item ) {
          <option [value]="item._id">{{ item.title }}</option>
          }
        </select>
        <field-error-component
          [field]="'value'"
          [label]="'integrations.fields.tag' | translate"
          [formGroup]="itemForm"
        />
      </div>
    </div>
  </div>
  } @else if(isStartAttendance()) {
  <div class="card-body">
    <div class="mb-2">
      <div class="d-flex align-items-start justify-content-between">
        <label class="text-dark fw-bold mb-1" style="font-size: 20px">
          {{ getLabel() }}
        </label>

        @if (!isRequired()) {
        <button
          type="button"
          class="btn btn-link p-0 ms-2"
          (click)="!isActive && deleteComponent()"
        >
          <i class="bi bi-trash fs-4 text-danger"></i>
        </button>
        }
      </div>

      <p class="text-muted mb-0">
        {{ itemForm.get("helpText")?.value || getMessage() }}
      </p>
    </div>
    <div class="col-12">
      <div class="mb-1">
        <mat-select class="form-control" formControlName="value"
          (selectionChange)="loadUsersByDepartment()"
          [placeholder]="'integrations.santriItem.selectDepartmentPlaceholder' | translate">
          @for(item of departments; track item ) {
            <mat-option [value]="item._id">{{ item.name }}</mat-option>
          }
        </mat-select>
        <field-error-component
          [field]="'value'"
          [label]="'integrations.fields.department' | translate"
          [formGroup]="itemForm"
        />
      </div>
      <div class="mb-1">
         <mat-select class="form-control" formControlName="attendent"
          [placeholder]="'integrations.santriItem.selectAttendantPlaceholder' | translate">
          @for(item of users; track item ) {
            <mat-option [value]="item._id">{{ item.name }}</mat-option>
          }
        </mat-select>
        <field-error-component
          [field]="'attendent'"
          [label]="'integrations.fields.attendant' | translate"
          [formGroup]="itemForm"
        />
      </div>
    </div>
  </div>
  } @else if (isAddContactGroup() || isRemoveContactGroup()) {
  <div class="card-body">
    <div class="mb-1">
      <div class="d-flex align-items-start justify-content-between">
        <label class="text-dark fw-bold mb-1" style="font-size: 20px">
          {{ getLabel() }}
        </label>
        @if (!isRequired()) {
        <button
          type="button"
          class="btn btn-link p-0 ms-2"
          (click)="!isActive && deleteComponent()"
        >
          <i class="bi bi-trash fs-4 text-danger"></i>
        </button>
        }
      </div>

      <p class="text-muted mb-0">
        {{ itemForm.get("helpText")?.value || getMessage() }}
      </p>
    </div>
    <select
      class="form-select"
      formControlName="value"
      [attr.placeholder]="'integrations.santriItem.selectContactGroupPlaceholder' | translate"
    >
      @for(group of groups; track $index ) {
      <option [value]="group._id">{{ group.name }}</option>
      }
    </select>
    <field-error-component
      [field]="'value'"
      [label]="'integrations.fields.contactGroup' | translate"
      [formGroup]="itemForm"
    />
  </div>
  } @else if (isSendMessage()) {
  <div class="card-body">
    <div class="mb-1">
      <div class="d-flex align-items-start justify-content-between">
        <label class="text-dark fw-bold mb-1" style="font-size: 20px">
          {{ getLabel() }}
        </label>
        @if (!isRequired()) {
        <button
          type="button"
          class="btn btn-link p-0 ms-2"
          (click)="!isActive && deleteComponent()"
        >
          <i class="bi bi-trash fs-4 text-danger"></i>
        </button>
        }
      </div>

      <p class="text-muted mb-0">
        {{ itemForm.get("helpText")?.value || getMessage() }}
      </p>
    </div>
    <div class="col-xs-12 mb-1">
      <div class="mb-1">
        <small class="text-muted">{{ 'integrations.santriItem.selectMessageTypeLabel' | translate }}</small>
        <mat-select class="form-control" formControlName="typeMessage">
          <mat-option [value]="'text'">{{ 'integrations.santriItem.messageTypeText' | translate }}</mat-option>
          <mat-option [value]="'image'">{{ 'integrations.santriItem.messageTypeImage' | translate }}</mat-option>
          <mat-option [value]="'audio'">{{ 'integrations.santriItem.messageTypeAudio' | translate }}</mat-option>
          <mat-option [value]="'video'">{{ 'integrations.santriItem.messageTypeVideo' | translate }}</mat-option>
          <mat-option [value]="'document'">{{ 'integrations.santriItem.messageTypeDocument' | translate }}</mat-option>
          <mat-option [value]="'button'">{{ 'integrations.santriItem.messageTypeButton' | translate }}</mat-option>
        </mat-select>
        <field-error-component
          [field]="'typeMessage'"
          [label]="'integrations.fields.messageType' | translate"
          [formGroup]="itemForm"
        />
      </div>
      <div class="col-12 mb-1">
        @if(isTypeMessageMedia() && itemForm.get('typeMessage').value !==
        'button') {
        <input
          class="form-control"
          maxlength="100"
          formControlName="caption"
          [placeholder]="'integrations.santriItem.captionPlaceholder' | translate"
        />
        }
      </div>
      <div class="col-xs-12 mb-1">
        @if (itemForm.get('typeMessage').value !== 'button') {
        <textarea
          #messageTextarea
          formControlName="value"
          class="form-control mb-1"
          (keydown)="onKeydown($event)"
          [placeholder]="'integrations.santriItem.typePlaceholder' | translate"
          maxlength="320"
          (paste)="onPaste($event)"
        ></textarea>
        <field-error-component
          [field]="'value'"
          [label]="'integrations.fields.text' | translate"
          [formGroup]="itemForm"
        />
        <div class="d-flex align-items-center justify-content-end gap-2 mt-2">
          <i
            class="bi bi-type-bold fs-3 text-dark"
            (click)="!isActive && applyFormat('bold')"
          ></i>
          <i
            class="bi bi-type-italic fs-3 text-dark"
            (click)="!isActive && applyFormat('italic')"
          ></i>
          <i
            class="bi bi-type-underline fs-3 text-dark"
            (click)="!isActive && applyFormat('underline')"
          ></i>

          <i
            class="bi bi-emoji-smile fs-3 text-dark"
            (click)="!isActive && toogleContainerEmoji()"
          ></i>
          <div
            #emojiContainer
            class="position-relative"
            id="emoji-container"
            style="display: none"
          >
            @if (showContainerEmoji) {
            <ng-container>
              <emoji-mart
                (emojiSelect)="!isActive && addEmoji($event)"
                [i18n]="translator"
                [darkMode]="false"
                class="position-absolute bottom-300 end-0 lg:bottom-100"
              >
              </emoji-mart>
            </ng-container>
            }
          </div>
          <button
            class="btn btn-primary fw-bold dropdown-toggle"
            type="submit"
            [matMenuTriggerFor]="menuRequest"
          >
            {{ 'integrations.santriItem.addRequestsButton' | translate }}
          </button>
          <mat-menu #menuRequest="matMenu">
            @for(request of webhookRequests | keyvalue; track $index){
            <button
              class="text-center"
              mat-menu-item
              (click)="!isActive && insertRequestOnMessage(request.key)"
            >
              {{ request.key }}
            </button>
            }
          </mat-menu>
        </div>
        }
      </div>
    </div>

    <!-- @if(itemForm.get('typeMessage').value === 'button') {
    <div class="row">
      <div class="col-12">
        <app-button-zapi-component
          [buttonActionsArray]="getButtonActionsFormArray()"
          [maxButtons]="3"
          [showFullMessage]="true"
          [title]="itemForm.get('title').value"
          [message]="itemForm.get('value').value"
          [footer]="itemForm.get('footer').value"
          (titleChange)="itemForm.get('title').setValue($event)"
          (messageChange)="itemForm.get('value').setValue($event)"
          (footerChange)="itemForm.get('footer').setValue($event)"
        >
        </app-button-zapi-component>
      </div>
    </div>
    } -->
  </div>
  }
</div>
